import React from 'react';
import LoadingBar from 'components/loading-bar';

const LoadingScreen = () => (
  <section className="hero is-fullheight has-text-centered">
    <div className="hero-body">
      <div className="container is-vcentered">
        <LoadingBar />
      </div>
    </div>
  </section>
);

export default LoadingScreen;



// WEBPACK FOOTER //
// ./src/components/loading-screen/loading-screen.js